import { BubbleMenu as Bubble } from '@tiptap/react';
import styled from 'styled-components';

const BubbleMenu = styled(Bubble)`
  padding: 10px 12px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white[100]};
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08);

  &.opacity-0 {
    opacity: 0;
  }
`;

export default BubbleMenu;
